import { useCallback, useState } from 'react';
import { INITIAL_AUDIT_STATES, getAuditState, nowStr } from './auditMock';

// 模块级存储：跨页面（我的定制 / 定制管理 / 详情）共享本次会话的审核状态
let AUDIT_STORE = { ...INITIAL_AUDIT_STATES };

/**
 * 定制申请审核状态（列表页 / 详情页共用）
 * 返回：
 * - getAudit(id)：取某项目审核状态 { status, history }
 * - getStatus(id)：取项目级定制状态（pending / approved / rejected）
 * - submit(id)：企业发起定制后进入「待审核」
 * - approve(id, comment)：平台客服审核通过
 * - reject(id, reason)：平台客服驳回（必填理由）
 * - resubmit(id)：企业对已驳回申请修改后重新提交
 */
export const useAudit = () => {
    const [, setVersion] = useState(0);
    const commit = useCallback((id, next) => {
        AUDIT_STORE = { ...AUDIT_STORE, [id]: next };
        setVersion((v) => v + 1);
    }, []);

    const getAudit = useCallback((id) => getAuditState(AUDIT_STORE, id), []);
    const getStatus = useCallback((id) => getAuditState(AUDIT_STORE, id).status, []);

    const submit = useCallback((id) => {
        commit(id, {
            status: 'pending',
            history: [{ action: 'submit', text: '企业提交定制申请', operator: '企业客户', time: nowStr() }],
        });
    }, [commit]);

    const approve = useCallback((id, comment) => {
        const cur = getAuditState(AUDIT_STORE, id);
        commit(id, {
            ...cur,
            status: 'approved',
            history: [...cur.history, { action: 'approve', text: comment ? `通过：${comment}` : '审核通过，开放资料填写', operator: '平台客服', time: nowStr() }],
        });
    }, [commit]);

    const reject = useCallback((id, reason) => {
        const cur = getAuditState(AUDIT_STORE, id);
        commit(id, {
            ...cur,
            status: 'rejected',
            history: [...cur.history, { action: 'reject', text: `驳回：${reason}`, operator: '平台客服', time: nowStr() }],
        });
    }, [commit]);

    const resubmit = useCallback((id) => {
        const cur = getAuditState(AUDIT_STORE, id);
        commit(id, {
            ...cur,
            status: 'pending',
            history: [...cur.history, { action: 'submit', text: '企业修改后重新提交定制申请', operator: '企业客户', time: nowStr() }],
        });
    }, [commit]);

    return { getAudit, getStatus, submit, approve, reject, resubmit };
};

export default useAudit;
